import { css } from "styled-components";

export const DividerStyles = css(
    ({ theme: { palette } }) => css`
        .Divider {
            background: ${palette.components.divider.background};
            height: ${palette.components.divider.height};
        }
    `,
);
